import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";


export class XwaysHoarder2GameAssets {
    public static BASE_BACK_PLATE: string = "reelBackground/mainReelBackground";
    public static FS_BACK_PLATE: string = "reelBackground/fsReelBackground";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FS_BACKGROUND: string = "freespinBackground";
    public static BINGE_BACKGROUND: string = "bingeBackground";
    public static SUPER_FS_BACKGROUND: string = "freespinBackground";


    public static BASE_GAME_FOREGROUND: string = "reelForeground/mainForeground";
    public static FREESPIN_FOREGROUND: string = "reelForeground/fsForeground";
    public static SUPER_FS_FOREGROUND: string = "reelForeground/fsForeground";
    public static BINGE_FOREGROUND: string = "reelForeground/bingeForeground";

    static STANDARD_X_BET_ON: string = "xBetOn@2x.png";
    static STANDARD_X_BET_OFF: string = "xBetOff@2x.png";
    static STANDARD_X_BET_BUBBLE: string = "X_Bet_Bubble.png";
    static STANDARD_X_BET_ATTENTION: string = "standard_x_bet_attention";

    static WIN_COUNT_UP = "winCountUp";
    static NUMBERS_MULTIPLIER = "multiplier";
    static MULTIPLIER_WHITE = "NumbersMultiplierWhite";
    static FS_INTRO_SPINS_COUNTUP = "FreeSpins";

    static BIG_WIN_SPINE = "spine/bigWin.json";
    static WIN_CAP_SPINE = "spine/maxWin.json";
    static LOOT_LIGHT = "spine/LootLight.json";
    static TRANSITION_DOORS = "spine/fs_doors.json";
    static LOOT_RESPIN = "spine/LootRespin.json";
    static SYM_LOCK = "spine/symLock.json";
    static XW_SPINE = "spine/XW.json";
    static SFS_INTRO_OUTRO = "spine/SFS_IntroOutro.json";
    static FS_INTRO_OUTRO = "spine/FS_IntroOutro.json";
    static BINGE_INTRO_OUTRO = "spine/BingeSpins_IntroOutro.json";
    static SYMBOL_REMOVE = "spine/SymbolRemove.json";
    static SYMBOL_REMOVE_EFFECT: string = "spine/SymbolRemoveReel.json";
    static SCATTER: string = "spine/Scatter.json";
    static SPLIT_REEL: string = "spine/SplitReel.json";
    static XW_MERGE = "spine/XW_Merge.json";
    static XSPLIT_ARROW: string = "spine/splitArrow.json";
    static XN_STOP: string = "spine/XN_StopFX.json";
    static PLUS_ONE: string = "spine/plus1FS.json";
    static WILD: string = "spine/Wild.json";
    static XSPLIT_NUDGE: string = "spine/xSplitNudge.json";
    static XSPLIT: string = "spine/xSplit.json";
    static FS_PROGRESS: string = "spine/FS_Progress.json";
    static RADIATION_SKULL: string = "spine/radiationSkull.json";
    static SCATTER_ANTICIPATION: string = "spine/excitement.json";

    static BG_TRANSITION_UNDER: string = "spine/BG_TransitionsUnder.json";
    static BG_TRANSITION_OVER: string = "spine/BG_TransitionsOver.json";

    static SPIN_BTN_FX: string = "spine/spinButtonFx.json";

    public static singleImages: string[] = [
        XwaysHoarder2GameAssets.STANDARD_X_BET_ON,
        XwaysHoarder2GameAssets.STANDARD_X_BET_OFF,
        XwaysHoarder2GameAssets.STANDARD_X_BET_BUBBLE
    ]
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],
        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(XwaysHoarder2GameAssets.WIN_COUNT_UP, "fonts/bitmapfonts/winCountUp.fnt"),
                    new BitmapFontAsset(XwaysHoarder2GameAssets.NUMBERS_MULTIPLIER, "fonts/bitmapfonts/multiplier.fnt"),
                    new BitmapFontAsset(XwaysHoarder2GameAssets.FS_INTRO_SPINS_COUNTUP, "fonts/bitmapfonts/FreeSpins.fnt"),
                    new BitmapFontAsset(XwaysHoarder2GameAssets.MULTIPLIER_WHITE, "fonts/bitmapfonts/NumbersMultiplierWhite.fnt")
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json")

                ],
                animations: {
                    "respinOverlay": "lootRespinOverlay"
                }
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json")
                ],
                animations: {
                    "lock_200": "symbolFx/1x1_Lock",
                    "lock_400": "symbolFx/2x1_Lock",
                    "lock_600": "symbolFx/3x1_Lock",
                    "winGlow": "effects/win/win_glow",
                    "winGlowSpin": "effects/win/win_glow_spin",
                    "inActive_levels": "FS_Outro_Indicators/Indicators_Inactive",
                    "Level_0": "FS_Outro_Indicators/0_active",
                    "Level_1": "FS_Outro_Indicators/1_active",
                    "Level_2": "FS_Outro_Indicators/2_active",
                    "Level_3": "FS_Outro_Indicators/3_active",
                    "Level_4": "FS_Outro_Indicators/4_active",
                    "xwaysBG": "ui/xWaysBg",
                    "xwaysOverlay": "ui/xWaysOverlay",
                    "lightBox": "ui/fsXwaysProgress",
                    "lightON": "ui/fsXwaysProgressLight",
                    "pinkLightON": "ui/fsXwaysProgressLight2",
                    "arrowXS": "symbolFx/arrow",
                    "SCReelAnticipation": "effects/excitement/excitement_"
                }
            },
            {
                name: "mainHigh",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json")
                ]
            },
            {
                name: "high32BitColor",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("high32BitColor0", "sheets/high32BitColor/high32BitColor0.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json")
                ],
                animations: {
                    "winGlow_100": "effects/winFx/winFrame/0_5x_win/0_5x_win_",
                    "winGlow_200": "effects/winFx/winFrame/1x1_win/1x1_win_",
                    "winGlow_400": "effects/winFx/winFrame/2x1_win/2x1_win_",
                    "winGlow_500": "effects/winFx/winFrame/2_5x1_win/2_5x1_win_",
                    "winGlow_600": "effects/winFx/winFrame/3x1_win/3x1_win_",
                    "winGlow_300": "effects/winFx/winFrame/1_5x1_win/1_5x1_win_",
                    "xWayRevealShadow_200": "effects/xW1x1",
                    "xWayRevealShadow_400": "effects/xWay2x1",
                    "xWayRevealShadow_500": "effects/xW2_5x1",
                    "xWayRevealShadow_600": "effects/xW3x1",
                    "winFx": "effects/winFx/countUpFx/countUpFx_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "frameX1": "XW/x1frame",
                    "frameX2": "XW/x2frame",
                    "frameX2_5": "XW/x2_5frame",
                    "frameX3": "XW/x3frame"
                }
            },
            {
                name: "symbolsRed",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsRed0", "sheets/symbolsRed/symbolsRed0.json"),
                    new TextureAsset("symbolsRed1", "sheets/symbolsRed/symbolsRed1.json")
                ],
                animations: {
                    "sscCopy": "SSC/SSC"
                }
            },
            {
                name: "symbolsGreen",
                autoLoad: [AssetQualityLevel.LOW, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsGreen0", "sheets/symbolsGreen/symbolsGreen0.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset(XwaysHoarder2GameAssets.BIG_WIN_SPINE, XwaysHoarder2GameAssets.BIG_WIN_SPINE),
                    new SpineAsset(XwaysHoarder2GameAssets.WIN_CAP_SPINE, XwaysHoarder2GameAssets.WIN_CAP_SPINE),
                    new SpineAsset(XwaysHoarder2GameAssets.LOOT_LIGHT, XwaysHoarder2GameAssets.LOOT_LIGHT),
                    new SpineAsset(XwaysHoarder2GameAssets.TRANSITION_DOORS, XwaysHoarder2GameAssets.TRANSITION_DOORS),
                    new SpineAsset(XwaysHoarder2GameAssets.LOOT_RESPIN, XwaysHoarder2GameAssets.LOOT_RESPIN),
                    new SpineAsset(XwaysHoarder2GameAssets.XSPLIT, XwaysHoarder2GameAssets.XSPLIT),
                    new SpineAsset(XwaysHoarder2GameAssets.SYM_LOCK, XwaysHoarder2GameAssets.SYM_LOCK),
                    new SpineAsset(XwaysHoarder2GameAssets.XW_SPINE, XwaysHoarder2GameAssets.XW_SPINE),
                    new SpineAsset(XwaysHoarder2GameAssets.SFS_INTRO_OUTRO, XwaysHoarder2GameAssets.SFS_INTRO_OUTRO),
                    new SpineAsset(XwaysHoarder2GameAssets.FS_INTRO_OUTRO, XwaysHoarder2GameAssets.FS_INTRO_OUTRO),
                    new SpineAsset(XwaysHoarder2GameAssets.BINGE_INTRO_OUTRO, XwaysHoarder2GameAssets.BINGE_INTRO_OUTRO),
                    new SpineAsset(XwaysHoarder2GameAssets.SYMBOL_REMOVE, XwaysHoarder2GameAssets.SYMBOL_REMOVE),
                    new SpineAsset(XwaysHoarder2GameAssets.SYMBOL_REMOVE_EFFECT, XwaysHoarder2GameAssets.SYMBOL_REMOVE_EFFECT),
                    new SpineAsset(XwaysHoarder2GameAssets.SCATTER, XwaysHoarder2GameAssets.SCATTER),
                    new SpineAsset(XwaysHoarder2GameAssets.SPLIT_REEL, XwaysHoarder2GameAssets.SPLIT_REEL),
                    new SpineAsset(XwaysHoarder2GameAssets.XW_MERGE, XwaysHoarder2GameAssets.XW_MERGE),
                    new SpineAsset(XwaysHoarder2GameAssets.XSPLIT_ARROW, XwaysHoarder2GameAssets.XSPLIT_ARROW),
                    new SpineAsset(XwaysHoarder2GameAssets.PLUS_ONE, XwaysHoarder2GameAssets.PLUS_ONE),
                    new SpineAsset(XwaysHoarder2GameAssets.XN_STOP, XwaysHoarder2GameAssets.XN_STOP),
                    new SpineAsset(XwaysHoarder2GameAssets.WILD, XwaysHoarder2GameAssets.WILD),
                    new SpineAsset(XwaysHoarder2GameAssets.XSPLIT_NUDGE, XwaysHoarder2GameAssets.XSPLIT_NUDGE),
                    new SpineAsset(XwaysHoarder2GameAssets.FS_PROGRESS, XwaysHoarder2GameAssets.FS_PROGRESS),
                    new SpineAsset(XwaysHoarder2GameAssets.RADIATION_SKULL, XwaysHoarder2GameAssets.RADIATION_SKULL),
                    new SpineAsset(XwaysHoarder2GameAssets.BG_TRANSITION_UNDER, XwaysHoarder2GameAssets.BG_TRANSITION_UNDER),
                    new SpineAsset(XwaysHoarder2GameAssets.BG_TRANSITION_OVER, XwaysHoarder2GameAssets.BG_TRANSITION_OVER),
                    new SpineAsset(XwaysHoarder2GameAssets.SCATTER_ANTICIPATION, XwaysHoarder2GameAssets.SCATTER_ANTICIPATION),
                    new SpineAsset(XwaysHoarder2GameAssets.SPIN_BTN_FX, XwaysHoarder2GameAssets.SPIN_BTN_FX)
                ]
            }
        ]
    }

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}